import { useCallback, useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getGrnAssetUnitListApi } from "../../../services/GrnService";
import { toast } from "react-toastify";
import Pagination from "../../Constant/Pagination";
import DebounceSearchInput from "../../Constant/DebounceSearchInput";
import { CancelRequest } from "../../../services/AxiosInstance";
import BarLoader from "../../../components/Loader/BarLoader";
import { CustomTooltip } from "../../../components/CustomTooltip";
import { FaInfo } from "react-icons/fa";
import { MultiActionDropdown, UnitStatusBadge } from "../../../components";

function GRNAssetUnitListCard({ grnId }) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({
    page: 1,
    page_size: 10,
    query: "",
  });

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await getGrnAssetUnitListApi(grnId, filter);
      setData(response.data.results);
      setTotal(response.data.count);
    } catch (error) {
      toast.error(error.response?.data?.error);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, [grnId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePagination = (page) => {
    const newPage = page.selected + 1;
    setFilter((prev) => ({ ...prev, page: newPage }));
  };

  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setFilter((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  return (
    <Card className="mt-2">
      <div className="data-table-wrapper">
        <div className="data-table-top">
          <h4>Asset Unit List</h4>
          <div className="d-flex align-items-center gap-4">
            <DebounceSearchInput handleSearchChange={handleSearchChange} />
            {/* <div className="w-100">
              <MultiActionDropdown
                variant="outline-primary"
                btnText="Add New Unit"
                btnIcon={null} // optional icon
                btnOnClick={() => alert("Primary Action")}
                menuOptions={[
                  { label: "Add New unit", onClick: () => {} },
                  { label: "Import From Excel", onClick: () => {} },
                ]}
              />
            </div> */}
          </div>
        </div>
      </div>
      {isLoading ? (
        <div className="text-center my-4">
          <BarLoader color="#255D5C" size={50} />
        </div>
      ) : (
        <>
          <div className="table-responsive">
            <table className="table border-less fs-6">
              <thead className="table-light custom-thead">
                <tr>
                  <th>Asset Number</th>
                  <th>Asset</th>
                  <th>Category</th>
                  <th>Delivery Location</th>
                  <th>Brand & Model</th>
                  <th>Purchase Cost</th>
                  <th>Purchase Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center py-4">
                      No GRN Assets Found.
                    </td>
                  </tr>
                ) : (
                  data.map((row, index) => (
                    <tr key={index} className="align-middle">
                      <td>
                        <Link to={`/asset/${row.id}/basic-details`}>
                          <strong>{row.asset_number}</strong>
                        </Link>
                      </td>
                      <td>
                        <span>{row.asset.name}</span>
                      </td>
                      <td>
                        <div className="d-flex flex-column">
                          <span>{row.asset.category}</span>
                          <span className="text-light">
                            {row.asset.sub_category}
                          </span>
                        </div>
                      </td>
                      <td>{row.delivery_location.name}</td>
                      <td>
                        <div className="d-flex align-item-center gap-1 ">
                          <span>
                            {row.brand} | {row.model_number}
                          </span>
                          <div>
                            <CustomTooltip
                              title={
                                <span className="d-flex flex-column">
                                  <span>MFG : {row.manufacturer || "N/A"}</span>
                                  <span>Brand : {row.brand || "N/A"}</span>
                                  <span>
                                    Model : {row.model_number || "N/A"}
                                  </span>
                                  <span>
                                    SL No. : {row.serial_number || "N/A"}
                                  </span>
                                </span>
                              }
                              arrow
                              placement="top"
                            >
                              <span
                                className="rounded-1 ms-1 btn btn-sm btn-outline-light"
                                style={{
                                  height: "auto",
                                  cursor: "pointer",
                                  padding: "0.2rem",
                                }}
                              >
                                <FaInfo size={10} className="text-dark" />
                              </span>
                            </CustomTooltip>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <em class="icon ni ni-sign-inr"></em>{" "}
                          <span>{row.purchase_cost}</span>
                        </div>
                      </td>
                      <td>{row.purchase_date}</td>
                      <td>
                        <UnitStatusBadge status={row.status} />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination below table */}
          <div className="mt-3">
            <Pagination
              currentPage={filter.page}
              recordsPage={filter.page_size}
              dataLength={total}
              handlePagination={handlePagination}
            />
          </div>
        </>
      )}
    </Card>
  );
}

export default GRNAssetUnitListCard;
